module.exports = __webpack_public_path__ + "static/media/ARtajmahal.84ebbbbd.jpg";